/*

This is used to omit a key value from a type interface or object. 

Ex: 

  type Item1 = { a: string, b: number, c: boolean };
  type Item2 = { a: number };

  type T2 = Omit<Item1, "a"> // { b: number, c: boolean };

Note this is different from the built in type helpe "Exclude".

eg: 
type excluded = Exclude<1 | 2 | 3 | 4,  2 | 3>;  // excluded === 1 | 4;

*/
export type Omit<T, K extends keyof T> = { [P in Exclude<keyof T, K>]: T[P] };

export function NoNulls<T>(item: T): item is NonNullable<T> {
  return item !== null;
}

export function filterNull<T>(array: T[]): NonNullable<T>[] {
  return array.filter<NonNullable<T>>(NoNulls);
}
